export default __webpack_public_path__ + "static/stackoverflow-2023-1f19ba3d299988672c9a28bd8c6c93e8.png";